<template>
  <div class="source-name-box">
    <div class="header">
        <div class="leftInfo">
            <span class="headerName">来源名称设置</span>
        </div>
        <div class="rightButton">
            <el-button type="primary" @click="templateConfigDrawer = true">添加模板</el-button>
        </div>
    </div>
     <div class="source-name-content">
         <div class="source-name-item">
             <div class="source-name-item-image">

             </div>
             <div class="source-name-item-name">
                 官网
             </div>
             <div class="source-name-item-type">
                 
             </div>
         </div>
     </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
@import url('../../assets/less/leadsSetting/sourceName.less');
</style>